module.exports = __webpack_public_path__ + "img/CLF_120_thumb.d0961131.jpg";